<template>
  <div :id="componentId+'-plot_area'" class="row">
  </div>
</template>
<script>
/* eslint-disable */
import * as d3 from "d3";
import {loadingCircle} from "../mixins/D3Mixin";

export default {
  name: "DateGraphWidget",
  props: ["plotData", "componentId", "advanced"],
  mixins: [loadingCircle],

  data() {
    return {
      divId: this.componentId + '-plot_area',
    }
  },

  watch: {
    plotData() {
      this.drawDatePlot()
    },


  },
  mounted() {
    this.initSvg();
  },


  methods: {

    initSvg() {
      this.divElement = document.getElementById(this.divId)
      this.drawDatePlot()
    },

    drawDatePlot() {
      if (this.divElement.childNodes.length > 0) {
        while (this.divElement.firstChild) {
          this.divElement.removeChild(this.divElement.lastChild);
        }
      }

      const margin = {top: 20, right: 20, bottom: 50, left: 40},
          width = 350 - margin.left - margin.right,
          height = 218 - margin.top - margin.bottom;

      if (this.plotData == null) {
        this.spinningCircle(margin, width, height)
      } else {
        if (this.plotData.data.length !== 0) {
          let cssCol = "col-12"
          let legend = false
          let svg_numbers = this.plotData.data.length
          if (this.plotData.data.length >= 2) {
            cssCol = "col-6"

          }
          if (this.advanced === "checked") {
            legend = true
          }
          let divElement = this.divElement
          let plotDataDomain = this.plotData.domain.ymax
          this.plotData.data.forEach(function (split, index) {

            const parseDate = d3.timeParse("%Y-%m-%d"); // for dates like "2014-01-01"
            //var parseDate = d3.time.format("%Y-%m-%dT00:00:00Z").parse;  // for dates like "2014-01-01T00:00:00Z"

            let brush = d3.brushX()                 // Add the brush feature using the d3.brush function
                .extent([[0, 0], [width, height]]) // initialise the brush area: start at 0,0 and finishes at width,height: it means I select the whole graph area
                .on("end", updateChart)

            let x = d3.scaleTime()
                .range([0, width]);


            let y = d3.scaleLinear()
                .range([height, 0]);

            let line = d3.line()
                .x(d => x(d.date))
                .y(d => y(d.occurrences));


            let svg = d3.select(divElement)
                .append("svg")
                .attr("class", cssCol)
                .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
                .append("g")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            var dataGroup = Array.from(d3.group(split.values, d => d.name));
            split.values.forEach(d => {
              d.csvdate = d.date.slice();
              d.date = parseDate(d.date);
              d.occurrences = d.occurrences;
            });


            let xDomain = d3.extent(split.values, d => d.date);
            x.domain(xDomain);
            y.domain([0, plotDataDomain]);

            let yAxis = svg.append("g")
                .call(d3.axisLeft(y));

            let xAxis = svg.append("g")
                .attr("transform", "translate(0," + height + ")")
                .call(d3.axisBottom(x));

            xAxis.selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-.7em")
                .attr("dy", ".13em")
                .attr("transform", "rotate(-30)");


            let div = d3.select("body").append("div3")
                .attr("class", "tooltip")
                .style("opacity", 0.5);


            function make_x_gridlines() {
              return d3.axisBottom(x)
            }

// gridlines in y axis function
            function make_y_gridlines() {
              return d3.axisLeft(y)
                  .ticks(5)
            }

            let clip = svg.append("defs").append("svg:clipPath")
                .attr("id", "clip2")
                .append("svg:rect")
                .attr("width", width)
                .attr("height", height)
                .attr("x", 0)
                .attr("y", 0);

            let plotArea = svg.append('g')
                // .attr("transform", `translate(${-margin.left/2},${-margin.top/2})`)
                .attr("clip-path", "url(#clip2)")

            svg.append("g")
                .attr("class", "brush")
                .call(brush);

            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", `translate(0,${height})`)
                .attr("stroke-opacity", 0.1)
                .call(make_x_gridlines()
                    .tickSize(-height)
                    .tickFormat("")
                )

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("stroke-opacity", 0.1)
                .call(make_y_gridlines()
                    .tickSize(-width)
                    .tickFormat("")
                )


            svg.append("text")
                .attr("text-anchor", "end")
                .attr("x", width)
                .attr("y", height + margin.top + 10)
                .text("");

            svg.append("text")
                .attr("text-anchor", "end")
                .attr("transform", "rotate(-90)")
                .attr("y", -margin.left + 16)
                .attr("x", -margin.top)
                .style("font-size", "70%")
                .text("%")

            if (legend){

              svg.append("text")
                  .attr('x', width / 2 -15)
                  .attr('y', function (d, i) {return (i * 12) + height+45;})
                  .text(split.group)
                  .attr('text-anchor', 'start')
                  .style("font-size", "15px")
                  .attr("alignment-baseline", "middle")
            }

            let paths = plotArea
                .selectAll("#paths")
                .append("g")
                .attr("id", "paths")
                .data(dataGroup)
                .enter()
                .append("path")
                .style("stroke", d => d.color = "#e8860e")
                .attr('d', d => line(d[1]))
                .attr('stroke', 'blue')
                .attr('stroke-width', 1)
                .attr('fill', 'none')
                .on("mouseover", function (event, d) {
                  div.transition()
                      .duration(200)
                      .style("opacity", 0.5);
                  div.html("tooltip")
                      .style("background-color", 'orange')
                      .style("opacity", 0.5)
                      .style("border-width", "3px")
                      .style("left", (event.pageX) + "px")
                      .style("top", (event.pageY - 50) + "px");
                })
                .on("mouseout", function (d) {
                  div.transition()
                      .duration(500)
                      .style("opacity", 0);
                });


            let idleTimeout

            function idled() {
              idleTimeout = null;
            }

            // A function that update the chart for given boundaries
            function updateChart(event) {

              let extent = event.selection
              // If no selection, back to initial coordinate. Otherwise, update X axis domain
              if (!extent) {
                if (!idleTimeout) return idleTimeout = setTimeout(idled, 350); // This allows to wait a little bit
                x.domain(xDomain);
              } else {
                x.domain([x.invert(extent[0]), x.invert(extent[1])])
                svg.select(".brush").call(brush.move, null) // This remove the grey brush area as soon as the selection has been done
              }

              // Update axis and circle position
              xAxis.transition().duration(1000).call(d3.axisBottom(x))
              xAxis.selectAll("text")
                  .style("text-anchor", "end")
                  .attr("dx", "-.7em")
                  .attr("dy", ".13em")
                  .attr("transform", "rotate(-30)");

              plotArea
                  .selectAll("path")
                  .transition().duration(1000)
                  .attr("d", function (d) {
                    return line(d[1]);
                  })
            }
          })
        } else {
          this.notEnoughData(margin, width, height)
        }
      }
    }
  }
}


</script>

<style scoped>

</style>